import { render } from "./HomePageSlider.vue?vue&type=template&id=cfb37a2e"
import script from "./HomePageSlider.vue?vue&type=script&lang=js"
export * from "./HomePageSlider.vue?vue&type=script&lang=js"

import "./HomePageSlider.vue?vue&type=style&index=0&id=cfb37a2e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__